import { render, staticRenderFns } from "./TurnoverDetail.vue?vue&type=template&id=2666ed8a&"
import script from "./TurnoverDetail.vue?vue&type=script&lang=js&"
export * from "./TurnoverDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports